import UiHelper from './UiHelper';

class PageMenu {
    static init() {
        this.wrap = document.querySelector('.js-limit-page-menu');
        if (!this.wrap) return;

        this.onResize = this.onResize.bind(this);

        const maxRows = this.getMaxRows(window.innerWidth);
        this.showInitialItems(maxRows);

        UiHelper.registerHandler('resize', this.onResize, 'throttle');
    }

    static onResize() {
        const maxRows = this.getMaxRows(window.innerWidth);
        this.showInitialItems(maxRows);
    }

    static showInitialItems(maxRows) {
        const links = Array.from(this.wrap.querySelectorAll('.sidebar-nav__item'));

        this.wrap.innerHTML = ''; // Clear existing content

        for (let i = 0; i < Math.min(links.length, 5); i++) {
            this.wrap.appendChild(links[i]);
        }

        if (links.length > 5) {
            const hiddenItems = document.createElement('div');
            hiddenItems.className = 'hidden-items';
            for (let i = 5; i < links.length; i++) {
                hiddenItems.appendChild(links[i].cloneNode(true));
            }
            this.wrap.appendChild(hiddenItems);
        }

        const toggleButton = document.createElement('a');
        toggleButton.href = '#';
        toggleButton.className = 'js-toggle-sidebar-nav sidebar-nav__toggle';
        toggleButton.innerHTML = '<div class="sidebar-nav__toggle-button"><i class="fa fa-fw fa-angle-down"></i></div>';
        toggleButton.addEventListener('click', e => {
            e.preventDefault();
            this.wrap.classList.toggle('show-all');
            toggleButton.classList.toggle('expanded');
            const iconWrapper = toggleButton.querySelector('.sidebar-nav__toggle-button');
            iconWrapper.innerHTML = this.wrap.classList.contains('show-all') ? '<i class="fa fa-fw fa-angle-up"></i>' : '<i class="fa fa-fw fa-angle-down"></i>';
        });
        this.wrap.appendChild(toggleButton);
    }

    static getMaxRows(windowWidth) {
        return windowWidth < 768 ? 6 : 100;
    }
}

export default PageMenu;

